import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.onboarding/onboarding", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function dismiss(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.onboarding/onboarding/dismiss", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function finish(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.onboarding/onboarding/finish", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
